import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Button } from '../ui';
import { UsersRoundIcon, SparklesIcon, RefreshCwIcon, DownloadIcon, UserIcon } from 'lucide-react';
export function GroupsPage() {
  const groups = [{
    name: 'Pod A (Strategy)',
    members: 6,
    criteria: 'Cross-functional, Mixed seniority'
  }, {
    name: 'Pod B (Operations)',
    members: 6,
    criteria: 'Cross-functional, Mixed seniority'
  }, {
    name: 'Pod C (Product)',
    members: 6,
    criteria: 'Cross-functional, Mixed seniority'
  }, {
    name: 'Pod D (Growth)',
    members: 6,
    criteria: 'Cross-functional, Mixed seniority'
  }];
  return <DashboardLayout pageTitle="Group Matching" breadcrumb="Leadership Reset Retreat" data-id="element-1485">
      <div className="flex flex-col md:flex-row gap-6 mb-8" data-id="element-1486">
        <div className="flex-1 bg-white rounded-2xl shadow-soft border border-slate-100 p-6" data-id="element-1487">
          <div className="flex items-center gap-3 mb-4" data-id="element-1488">
            <div className="w-10 h-10 rounded-full bg-brand-teal/10 flex items-center justify-center" data-id="element-1489">
              <SparklesIcon className="w-5 h-5 text-brand-teal" data-id="element-1490" />
            </div>
            <div data-id="element-1491">
              <h2 className="text-lg font-bold text-brand-navy" data-id="element-1492">
                AI Group Matching
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1493">
                Generate optimized groups based on intake data
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-3" data-id="element-1494">
            <Button variant="primary" size="sm" data-id="element-1495">
              <RefreshCwIcon className="w-4 h-4 mr-2" data-id="element-1496" /> Generate Pods (6-8 ppl)
            </Button>
            <Button variant="outline" size="sm" data-id="element-1497">
              <RefreshCwIcon className="w-4 h-4 mr-2" data-id="element-1498" /> Generate Buddy Pairs
            </Button>
            <Button variant="outline" size="sm" data-id="element-1499">
              Custom Criteria
            </Button>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-soft border border-slate-100 p-6 min-w-[250px]" data-id="element-1500">
          <h3 className="text-sm font-bold text-slate-700 mb-4 uppercase tracking-wider" data-id="element-1501">
            Current Setup
          </h3>
          <div className="space-y-3" data-id="element-1502">
            <div className="flex justify-between items-center text-sm" data-id="element-1503">
              <span className="text-slate-600" data-id="element-1504">Total Attendees</span>
              <span className="font-bold text-brand-navy" data-id="element-1505">48</span>
            </div>
            <div className="flex justify-between items-center text-sm" data-id="element-1506">
              <span className="text-slate-600" data-id="element-1507">Unassigned</span>
              <span className="font-bold text-amber-600" data-id="element-1508">0</span>
            </div>
            <div className="flex justify-between items-center text-sm" data-id="element-1509">
              <span className="text-slate-600" data-id="element-1510">Active Grouping</span>
              <span className="font-bold text-brand-teal" data-id="element-1511">Pods (8)</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center mb-6" data-id="element-1512">
        <h2 className="text-xl font-bold text-brand-navy" data-id="element-1513">Discussion Pods</h2>
        <Button variant="outline" size="sm" data-id="element-1514">
          <DownloadIcon className="w-4 h-4 mr-2" data-id="element-1515" /> Export List
        </Button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1516">
        {groups.map((group, i) => <div key={i} className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-1517">
            <div className="bg-slate-50 px-4 py-3 border-b border-slate-200 flex justify-between items-center" data-id="element-1518">
              <h3 className="font-bold text-brand-navy" data-id="element-1519">{group.name}</h3>
              <span className="bg-white text-slate-600 text-xs font-bold px-2 py-1 rounded-md border border-slate-200" data-id="element-1520">
                {group.members} ppl
              </span>
            </div>
            <div className="p-4" data-id="element-1521">
              <div className="text-[10px] uppercase tracking-wider font-semibold text-slate-400 mb-3" data-id="element-1522">
                Optimized for: {group.criteria}
              </div>
              <div className="space-y-2" data-id="element-1523">
                {Array.from({
              length: group.members
            }).map((_, j) => <div key={j} className="flex items-center gap-2 text-sm text-slate-700" data-id="element-1524">
                    <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center shrink-0" data-id="element-1525">
                      <UserIcon className="w-3 h-3 text-slate-400" data-id="element-1526" />
                    </div>
                    <span className="truncate" data-id="element-1527">Attendee Name {j + 1}</span>
                  </div>)}
              </div>
              <button className="w-full mt-4 py-2 text-xs font-medium text-brand-teal hover:bg-brand-teal/5 rounded-md transition-colors" data-id="element-1528">
                Edit Group
              </button>
            </div>
          </div>)}
      </div>
    </DashboardLayout>;
}